// Services
import apiClient from '@/services/AccountClient'

export default {
  fetchDisabled () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/features'
    )
  }
}
